import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { DatePicker, Popup } from "vant";
import "element-plus/dist/index.css";
import VueAxios from "vue-axios"; //追記
import "vant/lib/index.css";
import api from "@/api";

/**
 * リクエストから id を抽出（GET: URL クエリ / POST: body 優先）
 */
function extractId(config) {
  var method = (config.method || "get").toLowerCase();

  // POST/PUT/PATCH/DELETE は body 優先
  if (method !== "get" && config.data) {
    if (typeof config.data === "string") {
      try {
        var parsed = JSON.parse(config.data);
        if (parsed && parsed.id) return parsed.id;
      } catch (e) {
        /* JSON parse failure → ignore */
      }
    } else if (typeof config.data === "object" && config.data.id) {
      return config.data.id;
    }
  }

  // URL クエリパラメータから取得
  try {
    var url = new URL(config.url, window.location.origin);
    var queryId = url.searchParams.get("id");
    if (queryId) return queryId;
  } catch (e) {
    /* invalid URL → fallthrough */
  }

  // GET の場合のみ body フォールバック（通常は発生しない）
  if (method === "get" && config.data) {
    if (typeof config.data === "object" && config.data.id) {
      return config.data.id;
    }
  }

  return null;
}

// 機能8: 認証トークン自動付与インターセプタ（共通 api インスタンスに適用）
api.interceptors.request.use(function (config) {
  var id = extractId(config);
  if (id) {
    var entry = store.state.invalidationMap[id];
    // invalidationMap 未登録時はトークン付与をスキップ（checkInvalidation 完了前の
    // リクエストで誤った id を moveInId として使い 401 になる race condition を防止）
    if (entry && entry.moveInId) {
      var token = store.getters.getToken(entry.moveInId);
      if (token) {
        config.headers.Authorization = "Bearer " + token;
      }
    }
  }
  return config;
});

// 機能8: 起動時に localStorage から authMap を復元
store.dispatch("restoreAuth");

const app = createApp(App).use(store).use(router);
//app.use(Vue3Lottie, { name: "lottie" });
//app.use(ElementPlus);
app.use(VueAxios, api);
app.use(Popup);
app.use(DatePicker);
// let key = "Refresh";
// app.component(key, Refresh);
app.mount("#app");
